import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditCardValidators } from 'angular-cc-library';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { showDuration } from 'src/app/core/_constants/helper';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { OnlinePaymentComponent, fiveWordsValidator } from '../online-payment/online-payment.component';

export function nonZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = control.value > 0;
    return isValid ? null : { nonZero: true };
  };
}

@Component({
  selector: 'app-add-package',
  templateUrl: './add-package.component.html',
  styleUrls: ['./add-package.component.scss']
})
export class AddPackageComponent implements OnInit {

  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public packageFrom: FormGroup;
  submitted: boolean = false;
  durationArray = APP_CONSTANT.DURATION

  constructor(public dialogRef: MatDialogRef<OnlinePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public validationService: ValidationService,
    private service: PagesService,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,) {
  }


  ngOnInit(): void {
    this.packageFrom = this.createForm();
  }

  createForm() {
    return this.fb.group({
      packageName: ['', Validators.required],
      amount: ['', [Validators.required, Validators.min(0)]],
      truckAmount: ['', [Validators.required, Validators.min(0)]],
      aiRoutingAmount: ['', [Validators.required, Validators.min(0)]],
      emailMarketAmount: ['', [Validators.required, Validators.min(0)]],
      notificationsAmount: ['', [Validators.required, Validators.min(0)]],
      aiAgentAmount: ['', [Validators.required, Validators.min(0)]],
      duration: ['', [Validators.required]],
    })
  }

  get f() { return this.packageFrom.controls; }


  close(value: Boolean) {
    this.dialogRef.close(value);
  }

  addPackage() {
    this.submitted = true;
    if (this.packageFrom.valid) {
      const payload = {
        packageName: this.packageFrom.value.packageName,
        packagePrice: Number(this.packageFrom.value.amount),
        truckPrice: Number(this.packageFrom.value.truckAmount),
        aiRoutingPrice: Number(this.packageFrom.value.aiRoutingAmount),
        emailMarketingPrice: Number(this.packageFrom.value.emailMarketAmount),
        notificationsPrice: Number(this.packageFrom.value.notificationsAmount),
        aiPhoneAgentPrice: Number(this.packageFrom.value.aiAgentAmount),
        duration: this.packageFrom.value.duration
      }
      this.loader.start();
      this.service.post(payload, `${API_ROUTES.PACKAGES.createSubscriptionPackage}`).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.loader.stop();
            this.toastr.success(res.msg);
            setTimeout(() => {
              this.dialogRef.close(true);
            }, 500)
          } else {
            this.loader.stop();
            this.toastr.error(res);
          }
        },
        error: (err: any) => {
          this.loader.stop();
          this.toastr.error(err.msg);
        },
        complete: () => this.loader.stop()
      })
    }
  }

  getDuration(data) {
    return showDuration(data)
  }

  setTodecimal(): any {
    if (this.packageFrom.value.amount) {
      this.packageFrom.patchValue({ amount: Number(this.packageFrom.value.amount).toFixed(2) })
    }
    if (this.packageFrom.value.truckAmount) {
      this.packageFrom.patchValue({ truckAmount: Number(this.packageFrom.value.truckAmount).toFixed(2) })
    }
    if (this.packageFrom.value.aiRoutingAmount) {
      this.packageFrom.patchValue({ aiRoutingAmount: Number(this.packageFrom.value.aiRoutingAmount).toFixed(2) })
    }
    if (this.packageFrom.value.emailMarketAmount) {
      this.packageFrom.patchValue({ emailMarketAmount: Number(this.packageFrom.value.emailMarketAmount).toFixed(2) })
    }
    if (this.packageFrom.value.notificationsAmount) {
      this.packageFrom.patchValue({ notificationsAmount: Number(this.packageFrom.value.notificationsAmount).toFixed(2) })
    }
    if (this.packageFrom.value.aiAgentAmount) {
      this.packageFrom.patchValue({ aiAgentAmount: Number(this.packageFrom.value.aiAgentAmount).toFixed(2) })
    }
  }

}
